/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { html, View } from 'rune-ts';
import klass from './ModalSmallView.module.scss';
import { TRuneNode } from '@services/MarppleShop/shared/type/TRuneNode.ts';
import { classes } from '@services/MarppleShop/shared/util';
import { MShopUtilF } from '@modules/MShop/Util/F/Function/module/MShopUtilF';

export type TProps = {
  children: TRuneNode;
};

/**
 * @see ModalSmallAController
 *
 * https://www.figma.com/design/Top00pi5q5ylSxEviOOciV/MarppleShop-Design-System?node-id=20097-62378&m=dev
 *
 * https://www.figma.com/design/Top00pi5q5ylSxEviOOciV?node-id=18448-70286&m=dev#1397775618
 */
export class ModalSmallView extends View<TProps> {
  private resolve!: () => void;

  private readonly promise = new Promise<void>((resolve) => {
    this.resolve = resolve;
  });

  protected override onRender() {
    this.addEventListener('click', (event) => {
      if (event.target === this.element()) {
        this.close();
      }
    });
  }

  protected override onMount() {
    window.addEventListener('keydown', this.handleKeyDown);
  }

  protected override onUnmount() {
    window.removeEventListener('keydown', this.handleKeyDown);
  }

  open() {
    document.body.appendChild(this.render());
    MShopUtilF.bodyFixed$(true);
    return this.promise;
  }

  close() {
    return new Promise<void>((resolve) => {
      const backdropElement = this.element();
      const modalElement = this.element().querySelector(`.${klass.modal}`)!;

      backdropElement.classList.remove(klass.open);
      modalElement.addEventListener(
        'animationend',
        () => {
          this.element().remove();
          MShopUtilF.bodyFixed$(false);
          this.resolve();
          resolve();
        },
        {
          once: true,
        },
      );
      modalElement.classList.add(klass.slide_out);
    });
  }

  private handleKeyDown = (event: KeyboardEvent) => {
    if (event.code.toLowerCase() === 'escape') {
      const backdropElement = this.element();
      const modalElement = this.element().querySelector(`.${klass.modal}`)!;

      backdropElement.classList.remove(klass.open);
      modalElement.addEventListener('animationend', () => {
        this.element().remove();
        MShopUtilF.bodyFixed$(false);
        this.resolve();
      });
      modalElement.classList.add(klass.slide_out);
    }
  };

  protected override template({ children }: TProps) {
    return html`<div class="${classes(klass.backdrop, klass.open)}">
      <div class="${classes(klass.modal, klass.slide_in)}">${children}</div>
    </div>`;
  }
}
